<template>
  <ul id="thumbnails-list" class="mt-list is-flex">
  <Draggable v-model="imagesWithNumber" tag="ul" class="mt-list mt-list--uploaded-img is-flex" @start="onDragStart" @end="onDragEnd">
    <template #item="{ element: img, index }">
      <li id="thumbnails" :key="index" class="mt-list__item" data-qa-id="thumbnails">
        <figure class="mt-list--uploaded-img__img">
          <img id="thumbnail-image" :src="img.resourceLocation" data-qa-id="thumbnail-image" alt="thumbnail-img">
          <figcaption class="mt-list--uploaded-img__number is-flex is-flex--align-center is-flex--justify-center"
            data-qa-id="hover-text">
            {{ index + 1 }}
          </figcaption>
        </figure>
        <button id="delete-image-btn"
          class="mt-button mt-button--remove-img is-flex is-flex--align-center is-flex--justify-center"
          data-qa-id="delete-image-btn" :disabled="loading" @click="deleteImage(img.id, img.md5Checksum)">
          <Close :width="12" :height="12" />
        </button>
      </li>
    </template>
  </Draggable>
</ul>
</template>

<script src="./index.js" />

<style lang="scss">
@import "mpl-css/lib/assets/global/variables/fonts.scss";
@import "mpl-css/lib/assets/global/variables/colors.scss";
@import "mpl-css/lib/assets/global/variables/breakpoints.scss";

.mt-list--uploaded-img {
  flex-wrap: wrap;
  gap: 16px;
  padding: 24px;
  border: 1px solid map-get($colors, 'spirits--300');
  border-radius: 16px;
  margin-top: 32px;
  width: 100%;

  @media screen and (max-width: map-get($breakpoints, 's')) {
    margin-top: 24px;
  }

  .mt-list__item {
    width: 160px;
    height: 80px;
    border-radius: 8px;
    position: relative;

    @media screen and (max-width: map-get($breakpoints, 's')) {
      width: calc(25% - 12px);
      height: 65px;
    }

    @media screen and (max-width: 576px) {
      width: calc(50% - 8px);
      height: 65px;
    }

    .mt-list--uploaded-img__img {
      width: 100%;
      height: 100%;
      overflow: hidden;
      border-radius: 8px;
      margin: 0;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
      }

      .mt-list--uploaded-img__number {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1;
        transition: all 400ms ease-in-out;
        font-size: 28px;
        font-family: $mt-medium;
        color: map-get($colors, 'white');
        background-color: rgba($color: #000000, $alpha: 60%);
        border-radius: 8px;
        padding-top: 16px;
        opacity: 0;
        visibility: hidden;
      }

      &:hover {
        .mt-list--uploaded-img__number {
          opacity: 1;
          padding-top: 0;
          visibility: visible;
        }
      }
    }

    .mt-button--remove-img {
      position: absolute;
      top: -8px;
      right: -8px;
      background-color: map-get($colors, 'spirits--300');
      border: 1.5px solid map-get($colors, 'white');
      padding: 0;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      min-width: 0;
      z-index: 2;
    }
  }

}
</style>
